require("./compare.scss");

$(function () {

    function getTotalCols() { return $(".comparison-row-item:first .col-3:not(.d-none)").length; }

    $(".next").click(function () {

        $(".comparison-row-item .col-3:not(.d-none), .comparison-row-header .col-3:not(.d-none)").each((i, e) => {
            let newOrder = parseInt($(e).css("order")) - 1;

            if (newOrder < 1) newOrder = getTotalCols();

            $(e).css("order", newOrder);
        });

    });

    $(".prev").click(function () {

        $(".comparison-row-item .col-3:not(.d-none), .comparison-row-header .col-3:not(.d-none)").each((i, e) => {
            let newOrder = parseInt($(e).css("order")) + 1;

            if (newOrder > getTotalCols()) newOrder = 1;

            $(e).css("order", newOrder);
        });

    });

    $(".comparison-row-group").each((i, e) => {
        e.toggleCollapse = function () {
            $(e).parent().toggleClass("collapsed");
            $(e).find(".collapsed-icon").toggleClass("icon-up-arrow");
            $(e).find(".collapsed-icon").toggleClass("icon-down-arrow");
        }
    });

    $(".comparison-row-group").click(function () {
        this.toggleCollapse();
    });

    // if there are fewer than 3 items on the page, the pager & delete buttons should be hidden
    function checkHideControls() {
        var numCols = getTotalCols();
        if (numCols > 2) return;
        $(".pager").each(function () { this.style.setProperty("display", "none", "important"); });
        $(".btn-delete").toggleClass("d-none");
    }

    checkHideControls();

    $(".btn-delete").each(function (col, e) {
        $(e).click(function (ev) {
            let deletedOrder = parseInt($(e.parentNode.parentNode).css("order"));
            $(`.comparison-row-item .comparison-row-cell:nth-of-type(${col + 2}), .comparison-row-header .comparison-row-cell:nth-of-type(${col + 2})`).each(function () {
                $(this).toggleClass("d-none");
            });
            $("#num-items strong").html(function (i, oldHtml) {
                var numItems = parseInt(oldHtml) - 1;
                return numItems;
            });
            $(".comparison-row-item .col-3:not(.d-none), .comparison-row-header .col-3:not(.d-none)").each((i, e) => {
                let order = parseInt($(e).css("order"));
                if (order > deletedOrder) $(e).css("order", order - 1);
            });
            checkHideControls();
        });
    });

});